import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MaterialPriceListService } from '../../master/strategy-list/strategy-price-list.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CompanyCurrencyPipe } from 'app/pipes/currency.pipe';

@Component({
  selector: 'app-modal-price-list',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatTableModule,
    MatButtonModule,
    MatIcon,
    CompanyCurrencyPipe
  ],
  templateUrl: './modal-price-list.component.html',
  styleUrl: './modal-price-list.component.scss',
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({
        height: '0',
        minHeight: '0',
        padding: '0',
        margin: '0',
        visibility: 'hidden',
        opacity: '0',
        border: 'none'
      })),
      state('expanded', style({
        height: '*',
        visibility: 'visible',
        opacity: '1',
        padding: '1rem'
      })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class ModalPriceListComponent {

  displayedColumnsHistoric: string[] = [//"expand","codePriceList", 
  "namePriceList", "price", "igv"]
  dataSourceHistoric = new MatTableDataSource<any>([]);
  isExpansionDetailRow = (index: number, row: any) => row?.hasScalePrices && row?.expanded;

  constructor(
    private materialPriceListService: MaterialPriceListService,
    public dialogRef: MatDialogRef<ModalPriceListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    const soldToId = this.data?.order?.soldTo?._id;
    const materialId = this.data?.material?.material?._id;

    if (soldToId && materialId) {
      this.getPriceList(soldToId, materialId);
    } else {
      console.warn("No se encontró soldTo o material para obtener la lista de precios.");
    }
  }

  getPriceList(soldTo, material){
    this.materialPriceListService.getPriceListBySoldMaterial(soldTo, material).subscribe({
      next: (res: any) => {
        this.dataSourceHistoric.data = res?.data?.data ?? [];
      },
      error: (err) => {
       // this.snackBar.open(err.error.message || "Error al obtener registros","Cerrar",{ duration: 5000});
      },
    });
  }
}
